<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M11.0269 20.7631C16.5497 20.7631 21.0269 16.2859 21.0269 10.7631C21.0269 5.24021 16.5497 0.763062 11.0269 0.763062C5.50401 0.763062 1.02686 5.24021 1.02686 10.7631C1.02686 16.2859 5.50401 20.7631 11.0269 20.7631Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.52686 7.72839C8.52686 7.25111 8.52686 7.01247 8.6266 6.87924C8.71352 6.76314 8.84657 6.6905 8.99123 6.68016C9.15724 6.66831 9.35798 6.79736 9.75946 7.05545L14.4801 10.0901C14.8284 10.3141 15.0026 10.4261 15.0628 10.5685C15.1154 10.6929 15.1154 10.8333 15.0628 10.9577C15.0026 11.1001 14.8284 11.212 14.4801 11.436L9.75946 14.4707C9.35798 14.7288 9.15724 14.8578 8.99123 14.846C8.84657 14.8356 8.71352 14.763 8.6266 14.6469C8.52686 14.5137 8.52686 14.275 8.52686 13.7977V7.72839Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
